export default class SignDocumentsViewModel {
  columbus_phone = '5553772810';
}
